module.exports = __webpack_public_path__ + "static/media/sukumel.5b090edb.ogg";